/**
 * The API URL the iamu CLI should log in against (`iamu auth login --url`).
 *
 * The CLI calls `<url>/auth/cli/*` and `<url>/api/*` and keys stored
 * credentials by this URL, so it must be the API origin for this deployment:
 *
 * 1. `VITE_CLI_API_URL` — explicit override. The Vite dev server sets it to
 *    the local API (`http://localhost:${API_PORT}`), which matches the URL
 *    `pnpm local:link` stores credentials under.
 * 2. `VITE_API_URL` — the dashboard talks to a separate API origin.
 * 3. The dashboard's own origin — production serves the API same-origin
 *    (Caddy proxies `/api/*` and `/auth/cli/*` to the API).
 */
export function resolveCliApiUrl(env: {
  cliApiUrl?: string;
  apiUrl?: string;
  origin: string;
}): string {
  const url = env.cliApiUrl || env.apiUrl || env.origin;
  return url.replace(/\/+$/, "");
}

export function cliApiUrl(): string {
  return resolveCliApiUrl({
    cliApiUrl: import.meta.env.VITE_CLI_API_URL as string | undefined,
    apiUrl: import.meta.env.VITE_API_URL as string | undefined,
    origin: window.location.origin,
  });
}
